/**
 * swatch-preview.js — 2026-08-02 (v2 same day)
 *
 * Colour swatches on a product card become interactive:
 *   HOVER → the card image becomes that colour's variant photo.
 *   CLICK → opens the product page with that colour preselected, when the
 *           swatch carries a variant id; otherwise it just swaps the image.
 *
 * WHERE IT APPLIES: everywhere a swatch carries data-sw-img or data-sw-variant
 * — snippets/product-card.liquid (collections, native search, related) AND the
 * cards assets/semantic-search.js builds for semantic search results. This
 * listener is delegated at the document level precisely so both surfaces are
 * served by one implementation.
 *
 * ⚠ data-sw-variant is NAVIGATION-ONLY. For the 81 products where a colour
 * value repeats across sizes it is a first match standing for several real
 * variants, so it may deep-link the product page and must NEVER be added to a
 * cart. The same constraint is commented in product-card.liquid and in
 * semantic-search.js.
 *
 * DESIGN NOTES
 * - One listener for the document, not one per card; a collection page renders
 *   ~50 cards.
 * - Click is handled in the CAPTURE phase and preventDefault()ed, because the
 *   swatches sit inside the card's own <a>. Without that, a click would follow
 *   the card link before we could redirect it to the variant.
 * - Moving between swatches in the same row does not restore the original, so
 *   sweeping across the colours doesn't flicker.
 * - Swatches whose colour has no variant image carry no data-sw-img (3 variants
 *   across the catalogue) — they stay inert on hover and still navigate.
 * - Fail-soft: if anything here throws, the card is still a normal link.
 */
(function () {
  'use strict';

  var SW = '[data-sw-img],[data-sw-variant]';

  function swatchOf(e) {
    return e.target && e.target.closest ? e.target.closest(SW) : null;
  }

  function cardImage(el) {
    var wrap = el.closest('.product-card-wrap');
    return wrap ? wrap.querySelector('.product-card-image img') : null;
  }

  function show(sw) {
    var img = cardImage(sw);
    if (!img) return;
    var next = sw.getAttribute('data-sw-img');
    if (!next) return;
    if (!img.dataset.swOrig) img.dataset.swOrig = img.currentSrc || img.src;
    if (img.getAttribute('src') !== next) {
      img.removeAttribute('srcset');   // defensive: product cards ship a bare src
      img.setAttribute('src', next);
    }
  }

  function restore(sw) {
    var img = cardImage(sw);
    if (img && img.dataset.swOrig) img.setAttribute('src', img.dataset.swOrig);
  }

  document.addEventListener('mouseover', function (e) {
    var sw = swatchOf(e);
    if (sw) show(sw);
  });

  document.addEventListener('mouseout', function (e) {
    var sw = swatchOf(e);
    if (!sw) return;
    var row = sw.closest('.product-card-swatches');
    if (row && e.relatedTarget && row.contains(e.relatedTarget)) return;
    restore(sw);
  });

  document.addEventListener('click', function (e) {
    var sw = swatchOf(e);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();

    var variant = sw.getAttribute('data-sw-variant');
    var link = sw.closest('.product-card-wrap');
    link = link ? link.querySelector('a.product-card') : null;

    if (variant && link && link.getAttribute('href')) {
      var href = link.getAttribute('href');
      location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(variant);
      return;
    }
    show(sw);   // no variant id — fall back to the preview swap
  }, true);
})();
